import { render, staticRenderFns } from "./TicketsOverview.vue?vue&type=template&id=b893850e&scoped=true"
import script from "./TicketsOverview.vue?vue&type=script&lang=js"
export * from "./TicketsOverview.vue?vue&type=script&lang=js"
import style0 from "./TicketsOverview.vue?vue&type=style&index=0&id=b893850e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b893850e",
  null
  
)

export default component.exports